var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ChevronRight, Download, ExternalLink } from '@amsterdam/asc-assets';
import React from 'react';
import { deprecatedWarning } from '../../utils';
import LinkStyle, { ChevronIcon, LinkContent, RightIcon, } from './LinkStyle';
const Link = (_a) => {
    var { children, variant, as, icon, inList } = _a, otherProps = __rest(_a, ["children", "variant", "as", "icon", "inList"]);
    if (variant === 'with-chevron') {
        deprecatedWarning('Please note that the `with-chevron` variant will be deprecated soon, please use the `inList` prop');
    }
    if (icon && typeof icon !== 'string') {
        deprecatedWarning('Please note that passing a component to prop `icon` will be deprecated soon. If you need to use a custom Icon, just pass it as a child. If your link is a download or external link, you can pass `icon="download"` or `icon="external"`');
    }
    return (React.createElement(LinkStyle, Object.assign({}, otherProps, { variant: variant, forwardedAs: as }),
        (inList || variant === 'with-chevron') && (React.createElement(ChevronIcon, { size: 12 },
            React.createElement(ChevronRight, null))),
        inList || variant === 'with-chevron' ? (React.createElement(LinkContent, null, children)) : (children),
        (icon === 'external' || icon === 'download') && (React.createElement(RightIcon, { size: 14 },
            icon === 'external' && React.createElement(ExternalLink, null),
            icon === 'download' && React.createElement(Download, null))),
        icon && typeof icon !== 'string' && icon));
};
Link.defaultProps = {
    as: 'a',
};
export default Link;
//# sourceMappingURL=Link.js.map